export default {
  endpointHost: 'https://falcon-api.production.aws.ucastme.de',
  googleClientId:
    '9322604671-f092od1hhno2hnjk5v3ch35fb24sf61c.apps.googleusercontent.com',
};
